import React, {useState} from "react"
import {Tab, Stack, Grid} from "@mui/material";
import {checkQueryKey, formatTime, getSellerNames} from "@/helper/method";
import Box from "@mui/material/Box";
import {GridItem} from "@/widget/GridItem/GridItem";
import TabPanel from '@mui/lab/TabPanel';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import isEmpty from "lodash/isEmpty";
import {GridColDef,} from "@mui/x-data-grid";
import {ProTable} from "@/widget/ProTable/ProTable";
import {CopyrightPageVO, CopyrightVO, useQueryCopyright, useQueryCopyrightPage} from "@/service/copyright.s";
import {ContractDetail} from "@/widget/CommonDetail/ContractDetail";
import {useDrawerModal} from "@/store/global.c";
import {roleAlias, writeStatus} from "@/helper/constant";
import {PaybackTable} from "@/widget/CommonDetail/PaybackTable";
import {TaskTable} from "@/widget/CommonDetail/TaskTable";
import {FileTable} from "@/widget/CommonDetail/FileTable";
import {useAllDict} from "@/store/dict.c";
import Chip from "@mui/material/Chip";
import {useAuthInfo} from "@/store/account.c";
import {ContactDetail} from "@/widget/CommonDetail/PaybackDetail";

export const ViewCopyright = () => {
    const {id: drawerId} = useDrawerModal()
    const {data: copyrightData, isLoading: copyrightLoading} = useQueryCopyright({id: drawerId!})
    const [tab, setTab] = useState<number>(1)
    const {
        mutate: copyrightPageMutate,
        data: copyrightPageData,
        isPending: copyrightPagePending,
    } = useQueryCopyrightPage(0)
    const {copyrightFile} = useAllDict()
    const copyright = copyrightData?.data || {} as CopyrightVO
    const {role: {roleAlias: roleName}} = useAuthInfo()
    const copyrightColumns: GridColDef<CopyrightPageVO>[] = [
        {
            field: "copyrightName", headerName: "版权名称", flex: 0.5,
            renderCell: ({row}) => {
                return <Stack alignContent={'center'} alignItems={'center'} direction={'row'} spacing={0.5}>
                    {drawerId == row?.id && <Chip size={'small'} variant={'outlined'} color={'primary'} label={"当前"}/>}
                    <Box component={'span'}>
                        {isEmpty(row.copyrightName) ? '待定' : row.copyrightName}
                    </Box>
                </Stack>
            }
        },
        {
            field: "copyrightStatus",
            headerName: "版权状态", flex: 0.3
        },
        {
            field: "registerNo",
            headerName: "登记号", flex: 0.3,
            valueFormatter: value => value || "-"
        },
        {
            field: "releaseDate",
            headerName: "发布日期", flex: 0.4,
            valueFormatter: value => formatTime("D", value) || "-"
        },
        {
            field: "writer",
            headerName: "撰稿人",
            align: 'center',
            headerAlign: 'center',
            flex: 0.4
        },
    ];

    return <>
        <ResultWrapper isLoading={copyrightLoading} isEmpty={isEmpty(copyright)}>
            <Stack direction={'column'} width={'100%'} gap={2}>
                <Grid
                    spacing={3}
                    container>
                    <GridItem title={'版权名称'} content={copyright?.copyrightName}/>
                    <GridItem title={'服务类型'} content={copyright?.kind}/>
                    <GridItem title={'版权类型'} content={copyright?.category}/>
                    <GridItem title={'版权状态'} content={copyright?.copyrightStatus}/>
                    <GridItem title={'创作完成日期'} content={formatTime("D", copyright?.finishDate)}/>
                    <GridItem title={'登记日期'} content={formatTime("D", copyright?.registerDate)}/>
                    <GridItem title={'登记号'} content={copyright?.registerNo}/>
                    <GridItem title={'发布日期'} content={formatTime("D", copyright?.releaseDate)}/>
                </Grid>
                <TabContext value={tab}>
                    <Stack direction="column" spacing={2}>
                        <Box sx={{borderBottom: 1, borderTop: 1, pt: 1, borderColor: 'divider'}}>
                            <TabList variant={'fullWidth'} onChange={(event, value) => setTab(value)}>
                                <Tab label="详细信息" value={1}/>
                                {/*<Tab label="实施节点" value={8}/>*/}
                                <Tab label="合同" value={2}/>
                                <Tab label="对接人" value={9}/>
                                <Tab label="回款" value={5}/>
                                <Tab label="相关版权" value={3}/>
                                <Tab label="官方文件" value={4}/>
                            </TabList>
                        </Box>
                        <TabPanel value={1} sx={{mt: 1, p: 0}}>
                            <Stack direction={'column'} gap={2}>
                                <Grid
                                    spacing={3} container>
                                    <GridItem title={'客户名称'} content={copyright?.customerName}/>
                                    <GridItem title={'联系人'} content={copyright?.contact}/>
                                    <GridItem title={'联系电话'} content={copyright?.mobile}/>
                                    <GridItem title={'业务人员'} content={getSellerNames(copyright?.creator, copyright?.seller)}/>
                                    <GridItem title={'价格'} content={copyright?.price}/>
                                    <GridItem title={'分配人'} content={copyright?.assigner}/>
                                    <GridItem title={'分配时间'} content={formatTime("D", copyright?.assignTime)}/>
                                    <GridItem title={'撰稿人'} content={copyright?.writer}/>
                                    <GridItem title={'接收时间'} content={formatTime("D", copyright?.receiveTime)}/>
                                    <GridItem title={'内部期限'} content={formatTime("D", copyright?.insideDeadline)}/>
                                    <GridItem title={'撰写状态'} content={copyright?.writeStatus}/>
                                    <GridItem title={`${writeStatus[copyright.writeStatusId] || ''}时间`} content={formatTime("D", copyright?.writeStatusTime)}/>
                                    <GridItem size={12} minHeight={80} content={copyright?.explain} title={'备注'}/>
                                    <GridItem title={'更新时间'} content={formatTime('D', copyright?.updatedAt)}/>
                                    <GridItem title={'创建时间'} content={formatTime('D', copyright?.createdAt)}/>
                                </Grid>
                            </Stack>
                        </TabPanel>
                        <TabPanel value={2} sx={{p: 0}}>
                            <ContractDetail data={copyright?.contract}/>
                        </TabPanel>
                        <TabPanel value={3} sx={{p: 0}}>
                            <ProTable<CopyrightPageVO> loading={copyrightPagePending} checkboxSelection={false}
                                                       showToolbar={false}
                                                       onSearch={(params) => checkQueryKey(copyright?.contractId) && copyrightPageMutate({
                                                           ...params,
                                                           contractId: copyright?.contractId
                                                       })}
                                                       data={copyrightPageData?.data} pageSize={5}
                                                       columns={copyrightColumns} columnHeaderHeight={46}/>
                        </TabPanel>
                        <TabPanel value={4} sx={{p: 0}}>
                            <FileTable disabled={!(roleName == roleAlias['processer'])} tag={23} targetId={drawerId} checkboxSelection={true} options={copyrightFile}/>
                        </TabPanel>
                        <TabPanel value={5} sx={{p: 0}}>
                            <PaybackTable enabled={false} data={copyright?.paybacks}/>
                        </TabPanel>
                        <TabPanel value={8} sx={{p: 0}}>
                            <TaskTable/>
                        </TabPanel>
                        <TabPanel value={9} sx={{p: 0}}>
                            <ContactDetail id={copyright?.contract?.contactId}/>
                        </TabPanel>
                    </Stack>
                </TabContext>
            </Stack>
        </ResultWrapper>
    </>
};


